<template>
  <div>
    <v-toolbar color="secondary" dark tabs>
      <v-toolbar-title>{{$tc('design.property', 2)}}</v-toolbar-title>
      <v-tabs
        v-model="tabs"
        centered
        color="secondary"
        slot="extension"
        slider-color="accent"
      >
        <v-tab
          :href="`#tab-library-image${id}-general`"
          ripple
        >
          {{$t('general.general')}}
        </v-tab>
        <v-tab
          :href="`#tab-library-image${id}-states`"
          ripple
        >
          {{$tc('design.state', 2)}}
        </v-tab>
      </v-tabs>
    </v-toolbar>

    <v-card-text>
      <v-tabs-items v-model="tabs">
        <v-tab-item :value="`tab-library-image${id}-general`">
          <v-layout row wrap>
            <v-flex xs12  pb-0>
              <h3><b>{{$t('design.position')}}</b></h3>
            </v-flex>
            <v-flex xs4 pt-1 pb-0>
              <v-text-field
                v-model.number="x"
                name="pos-x"
                label="X"
                id="pos-x"
                type="number"
                disabled
              ></v-text-field>
            </v-flex>
            <v-flex xs4 pt-1 pb-0>
              <v-text-field
                v-model.number="y"
                name="pos-y"
                label="Y"
                id="pos-y"
                type="number"
                disabled
              ></v-text-field>
            </v-flex>
            <v-flex xs4 pt-1 pb-0>
              <v-text-field
                v-model.number="r"
                name="rotation"
                label="Rotation"
                id="rotation"
                type="number"
                disabled
              ></v-text-field>
            </v-flex>
            <v-flex xs12 pt-1 pb-0>
              <v-text-field
                v-model.number="zIndex"
                name="z-index"
                :label="$t('design.zIndex')"
                id="z-index"
                type="number"
                min="0"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 pt-1 pb-0>
              <h3><b>{{$t('design.size')}}</b></h3>
            </v-flex>
            <v-flex xs6 pt-1 pb-0>
              <v-text-field
                v-model.number="w"
                name="size-w"
                :label="$t('design.width')"
                id="size-w"
                type="number"
                disabled
              ></v-text-field>
            </v-flex>
            <v-flex xs6 pt-1 pb-0>
              <v-text-field
                v-model.number="h"
                name="size-h"
                :label="$t('design.height')"
                id="size-h"
                type="number"
                disabled
              ></v-text-field>
            </v-flex>
<!-- ############## -->
            <v-flex xs12 pt-1 pb-0>
              <h3><b>{{$t('design.directorFlags')}}</b></h3>
            </v-flex>
            <DirectorFlagsPropertyPlugin v-bind:directorFlags.sync="directorFlags" />

            <v-flex xs12 pt-1 pb-0>
              <h3><b>{{$t('design.padding')}}</b></h3>
            </v-flex>
            <v-flex xs3 pt-1 pb-0>
              <v-text-field
                v-model.number="paddingLeft"
                name="padding_left"
                :label="$t('design.left')"
                id="padding-left"
                type="number"
              ></v-text-field>
            </v-flex>
            <v-flex xs3 pt-1 pb-0>
              <v-text-field
                v-model.number="paddingTop"
                name="padding_top"
                :label="$t('design.top')"
                id="padding-top"
                type="number"
              ></v-text-field>
            </v-flex>
            <v-flex xs3 pt-1 pb-0>
              <v-text-field
                v-model.number="paddingRight"
                name="padding_right"
                :label="$t('design.right')"
                id="padding-right"
                type="number"
              ></v-text-field>
            </v-flex>
            <v-flex xs3 pt-1 pb-0>
              <v-text-field
                v-model.number="paddingBottom"
                name="padding_bottom"
                :label="$t('design.bottom')"
                id="padding-bottom"
                type="number"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 pt-1 pb-0>
              <h3><b>{{$t('design.image')}}</b></h3>
            </v-flex>

            <v-flex xs12 pt-1 pb-0>
              <v-text-field
                v-model="name"
                data-vv-name="name"
                :label="$t('design.url')"
                name="name"
                disabled
              ></v-text-field>
            </v-flex>

            <v-flex xs12 pt-0 pb-0>
              <h3><b>{{$tc('design.color', 2)}}</b></h3>
            </v-flex>
            <v-flex xs12 d-inline-flex pt-1 pb-0>
              <color-picker
                :color-type="'backgroundColor'"
                :label="$t('design.background')"
                :name="'background_color'"
              ></color-picker>
            </v-flex>

            <v-flex xs12 pt-1 pb-0>
              <v-checkbox
                :label="$t('design.allowDeformation')"
                :value="deformation"
                :input-value="deformation"
                :false-value="0"
                :true-value="1"
                v-model="deformation"
                @change="toggleDeformation()"
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-tab-item>
        <v-tab-item :value="`tab-library-image${id}-states`">
          <widget-states></widget-states>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </div>
</template>

<script>
import { mapWidgets } from './WidgetPropertiesUtils';
import WidgetPropertiesMixin from './WidgetPropertiesMixin';
import WidgetStates from './WidgetStates.vue';
import ColorPicker from './ColorPicker.vue';
import DirectorFlagsPropertyPlugin from './DirectorFlagsPropertyPlugin.vue';

export default {
  mixins: [WidgetPropertiesMixin],
  components: {
    WidgetStates,
    ColorPicker,
    DirectorFlagsPropertyPlugin,
  },
  computed: {
    ...mapWidgets(
      [
        {
          path: 'data',
          key: 'name',
        },
        {
          path: 'style',
          key: 'justifyContent',
        },
        {
          path: 'style',
          key: 'alignItems',
        },
        {
          path: 'style',
          key: 'deformation',
        },
        {
          path: 'style',
          key: 'paddingLeft',
        },
        {
          path: 'style',
          key: 'paddingTop',
        },
        {
          path: 'style',
          key: 'paddingRight',
        },
        {
          path: 'style',
          key: 'paddingBottom',
        },
        {
          path: 'style',
          key: 'backgroundColor',
        },
        {
          path: 'style',
          key: 'zIndex',
        },
        {
          path: 'style',
          key: 'directorFlags',
        },
        {
          path: 'style',
          key: 'w',
        },
        {
          path: 'style',
          key: 'h',
        },
        {
          path: 'style',
          key: 'x',
        },
        {
          path: 'style',
          key: 'y',
        },
        {
          path: 'style',
          key: 'r',
        },
      ],
    ),
  },
  data() {
    return {
      tabs: null,
    };
  },
};
</script>

<style scoped>
input:disabled {
  color: rgba(0, 0, 0, 0.26) !important;
  -webkit-text-fill-color: rgba(0, 0, 0, 0.26) !important;
}
</style>
